var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "borderColor mb-4 p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('h5', {
    staticClass: "font-weight-bold m-0 text-secondary"
  }, [_vm._v("通 知 設 定")]), _c('v-tooltip', {
    attrs: {
      "right": "",
      "color": "black"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('i', _vm._g(_vm._b({
          staticClass: "far fa-question-circle pl-2 text-secondary"
        }, 'i', attrs, false), on))];
      }
    }])
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("請至 通知設定指南"), _c('br'), _vm._v("設定群組名稱")])]), _c('button', {
    staticClass: "confirmButton ml-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v(" 儲存 ")])], 1), _c('v-expansion-panels', {
    attrs: {
      "multiple": "",
      "flat": "",
      "tile": ""
    },
    model: {
      value: _vm.panel,
      callback: function callback($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    staticClass: "border my-2"
  }, [_c('v-expansion-panel-header', {
    attrs: {
      "color": "acme_blue_light"
    }
  }, [_vm._v(" 選擇通知項目 ")]), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "mt-5 mb-3"
  }, [_c('div', {
    staticClass: "p-1"
  }, [_vm._v("系統")]), _c('div', [_c('v-checkbox', {
    staticClass: "d-inline-block",
    attrs: {
      "hide-details": "",
      "label": "全選",
      "dense": ""
    },
    on: {
      "click": function click($event) {
        return _vm.handleCheckSystem(_vm.isCheckedSystem);
      }
    },
    model: {
      value: _vm.isCheckedSystem,
      callback: function callback($$v) {
        _vm.isCheckedSystem = $$v;
      },
      expression: "isCheckedSystem"
    }
  })], 1), _vm._l(_vm.systemAlarmOptions, function (alarm, aIdx) {
    return _c('v-checkbox', {
      key: alarm.value + aIdx,
      staticClass: "d-inline-block mr-8",
      attrs: {
        "label": alarm.label,
        "value": alarm.value,
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: _vm.selectedSystemAlarms,
        callback: function callback($$v) {
          _vm.selectedSystemAlarms = $$v;
        },
        expression: "selectedSystemAlarms"
      }
    });
  }), _c('v-divider'), _c('div', {
    staticClass: "p-1"
  }, [_vm._v("事件")]), _c('div', [_c('v-checkbox', {
    staticClass: "d-inline-block",
    attrs: {
      "hide-details": "",
      "label": "全選",
      "dense": ""
    },
    on: {
      "click": function click($event) {
        return _vm.handleCheckEvent(_vm.isCheckedEvent);
      }
    },
    model: {
      value: _vm.isCheckedEvent,
      callback: function callback($$v) {
        _vm.isCheckedEvent = $$v;
      },
      expression: "isCheckedEvent"
    }
  })], 1), _vm._l(_vm.eventAlarmOptions, function (event, eIdx) {
    return _c('v-checkbox', {
      key: event.value + eIdx,
      staticClass: "d-inline-block",
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "label": event.label,
        "value": event.value,
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: _vm.selectedEventAlarms,
        callback: function callback($$v) {
          _vm.selectedEventAlarms = $$v;
        },
        expression: "selectedEventAlarms"
      }
    });
  })], 2)])], 1), _c('v-expansion-panel', {
    staticClass: "border my-2"
  }, [_c('v-expansion-panel-header', {
    attrs: {
      "color": "acme_blue_light"
    }
  }, [_vm._v(" 選擇通知方式 ")]), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "mt-5 mb-3"
  }, _vm._l(_vm.types, function (t, tIdx) {
    return _c('v-checkbox', {
      key: t.value + tIdx,
      staticClass: "d-inline-block mr-8",
      attrs: {
        "label": t.label,
        "value": t.value,
        "hide-details": "",
        "dense": "",
        "disabled": t.value !== 'mailGroup'
      },
      on: {
        "change": function change($event) {
          return _vm.handleCheckType(t.value);
        }
      },
      model: {
        value: _vm.selectedTypes,
        callback: function callback($$v) {
          _vm.selectedTypes = $$v;
        },
        expression: "selectedTypes"
      }
    });
  }), 1)])], 1), _c('v-expansion-panel', {
    staticClass: "border my-2"
  }, [_c('v-expansion-panel-header', {
    attrs: {
      "color": "acme_blue_light"
    }
  }, [_vm._v(" 輸入群組名稱 "), _c('span', {
    staticClass: "ml-8 text-danger"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]), _c('v-expansion-panel-content', [_c('div', {
    staticClass: "mt-7 mb-3"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex flex-wrap align-items-start"
  }, _vm._l(_vm.selectedTypes, function (type) {
    return _c('div', {
      key: type,
      staticClass: "border groupBox p-3 rounded-md"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', [_vm._v(_vm._s(_vm.typeMap.get(type)) + " 群組名稱")]), _c('v-btn', {
      staticClass: "btn_meter_add ml-auto",
      attrs: {
        "color": "#ebebeb",
        "fab": "",
        "depressed": "",
        "outlined": "",
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.handleAddGroupName(type);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#a3a3a3"
      }
    }, [_vm._v("mdi-plus")])], 1)], 1), _vm._l(_vm.groups[type], function (_item, idx) {
      return _c('div', {
        key: type + idx,
        staticClass: "d-flex my-3"
      }, [_c('b-form-input', {
        staticClass: "textInput mr-3",
        attrs: {
          "size": "sm"
        },
        on: {
          "blur": function blur($event) {
            return _vm.inputGroupName(type, idx);
          }
        },
        model: {
          value: _vm.groups[type][idx],
          callback: function callback($$v) {
            _vm.$set(_vm.groups[type], idx, $$v);
          },
          expression: "groups[type][idx]"
        }
      }), _c('v-btn', {
        attrs: {
          "color": "#ebebeb",
          "fab": "",
          "depressed": "",
          "outlined": "",
          "x-small": ""
        },
        on: {
          "click": function click($event) {
            return _vm.handleRemoveGroupName(type, idx);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "#a3a3a3"
        }
      }, [_vm._v("mdi-minus")])], 1)], 1);
    })], 2);
  }), 0)])])])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };